import parameters from '@atlassian/jira-relay/src/__generated__/EntryPointContentQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncBulkOpsCoreFullEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-bulkOps-core-full" */ './src/EntryPointContent.tsx'),
	),
	getPreloadProps: ({ cloudId }: { cloudId: string }) => ({
		queries: {
			permissionsQuery: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					cloudId,
				},
			},
		},
	}),
});
